import { createContext, useState, useEffect } from 'react';

import { translatedText } from '../Shared/Data/Language/translated-text';

export const LanguageContext = createContext({
    language: '',
    setLanguage: () => { },
    translatedText: {},
});

export const LanguageProvider = ({ children }) => {

    const getInitialLanguage = () => {
        // Check local storage for user preference first
        const storedLang = localStorage.getItem('language');
        if (storedLang) return storedLang;

        // If not stored, detect browser language
        const navigatorLang = navigator.language || navigator.userLanguage;
        return navigatorLang.startsWith('fr') ? 'FR' : 'EN';
    };

    const [language, setLanguage] = useState(getInitialLanguage);

    // Sync changes to localStorage whenever user manually changes language
    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);



    const value = {
        language,
        setLanguage,
        translatedText: translatedText[language],
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};